import { render, staticRenderFns } from "./WaitingForFinalOrder.vue?vue&type=template&id=90e96ab6&"
import script from "./WaitingForFinalOrder.vue?vue&type=script&lang=ts&"
export * from "./WaitingForFinalOrder.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports